import AddUserModal from '../../components/admin/AddUserModal'
import DraftPostDetail from '../../components/admin/DraftPostDetail'
import DraftPostList from '../../components/admin/DraftPostList'
import EditUserModal from '../../components/admin/EditUserModal'
import UserDetail from '../../components/admin/UserDetail'
import UserList from '../../components/admin/UserList'
import ResearchResultsPanel from '../../components/admin/research-results/ResearchResultsPanel'
import { useAdminStore } from '../../stores/adminStore'
import React from 'react'

const MainPanelContent: React.FC = () => {
    const adminView = useAdminStore((state) => state.adminView)
    const selectedUserId = useAdminStore((state) => state.selectedUserId)

    if (adminView === 'content') {
        return (
            <>
                <DraftPostList />
                <DraftPostDetail />
            </>
        )
    } else if (adminView === 'users') {
        return (
            <div className="flex-grow bg-white overflow-y-auto">
                {selectedUserId ? (
                    <UserDetail />
                ) : (
                    <div className="p-8 flex justify-center items-center h-full">
                        <p className="text-gray-500 italic">
                            Select a user to view details, or add a new user.
                        </p>
                    </div>
                )}
            </div>
        )
    } else if (adminView === 'research') {
        return <ResearchResultsPanel />
    }
    return null
}

const AdminDashboardContent: React.FC = () => {
    const adminView = useAdminStore((state) => state.adminView)
    const setAdminView = useAdminStore((state) => state.setAdminView)

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col h-screen">
            <div className="py-4 px-6 bg-white shadow-sm border-b border-gray-200 flex-shrink-0">
                <h1 className="text-xl font-semibold text-gray-800">Admin Dashboard</h1>
            </div>
            <div className="px-6 pt-4 bg-gray-50 border-b border-gray-200 flex-shrink-0">
                <div className="flex space-x-1">
                    <button
                        onClick={() => setAdminView('content')}
                        className={`px-4 py-2 rounded-t-md text-sm font-medium ${
                            adminView === 'content'
                                ? 'bg-white border-gray-200 border-l border-t border-r text-indigo-600'
                                : 'bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700'
                        }`}
                    >
                        Content Moderation
                    </button>
                    <button
                        onClick={() => setAdminView('users')}
                        className={`px-4 py-2 rounded-t-md text-sm font-medium ${
                            adminView === 'users'
                                ? 'bg-white border-gray-200 border-l border-t border-r text-indigo-600'
                                : 'bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700'
                        }`}
                    >
                        User Management
                    </button>
                    <button
                        onClick={() => setAdminView('research')}
                        className={`px-4 py-2 rounded-t-md text-sm font-medium ${
                            adminView === 'research'
                                ? 'bg-white border-gray-200 border-l border-t border-r text-indigo-600'
                                : 'bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700'
                        }`}
                    >
                        Research Results
                    </button>
                </div>
            </div>
            <div className="flex-grow flex overflow-hidden">
                <UserList />
                <MainPanelContent />
            </div>
            <AddUserModal />
            <EditUserModal />
        </div>
    )
}

const AdminDashboard: React.FC = () => {
    return <AdminDashboardContent />
}

export default AdminDashboard
